import React from 'react';

const About = () => {
  return (
    <div className="container p-4">
      <h1>About Us</h1>
      <p>
        Welcome to our platform! We are dedicated to providing the best services to our customers. Our mission is to make your experience seamless, enjoyable, and efficient.
      </p>

      <h2>Our Vision</h2>
      <p>
        Our vision is to revolutionize the way people interact with food services by offering innovative solutions and exceptional customer service.
      </p>

      <h2>Our Mission</h2>
      <p>
        We aim to connect people with their favorite restaurants and food services while ensuring quality, reliability, and convenience.
      </p>

      <h2>Why Choose Us?</h2>
      <ul>
        <li>Wide range of restaurants and cuisines to choose from.</li>
        <li>Fast and reliable service.</li>
        <li>Easy-to-use platform for ordering and managing your preferences.</li>
        <li>Dedicated customer support to assist you at every step.</li>
      </ul>

      <h2>Contact Us</h2>
      <p>
        Have questions or feedback? We'd love to hear from you! Reach out to us at <a href="mailto:support@platoo.com">support@platoo.com</a>.
      </p>
    </div>
  );
};

export default About;